import { useTranslation } from "next-i18next";
import { Modal, ModalCloseButton, ModalOpenButton } from "./Dialog";
import { useState } from "react";

import { useEffect } from "react";

interface ConfirmationOverlayProps {
  onClick?: () => void;
  children: React.ReactElement;
  description?: string;
  confirmationMessage?: string;
  dismissMessage?: string;
  type?: "Submit" | "Button";
  isSubmitting: boolean;
}
export function ConfirmationOverlay({
  children,
  onClick,
  description,
  confirmationMessage,
  dismissMessage,
  type = "Button",
  isSubmitting,
}: ConfirmationOverlayProps) {
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [confirmClicked, setConfirmClicked] = useState(false);

  useEffect(() => {
    if (confirmClicked && !isSubmitting) {
      setDialogOpen(false);
      setConfirmClicked(false);
    }
  }, [isSubmitting, confirmClicked]);

  const handleConfirmClick = () => {
    if (onClick) {
      onClick();
    }
    setConfirmClicked(true);
  };

  return (
    <>
      <ModalOpenButton setOpen={setDialogOpen}>{children}</ModalOpenButton>
      <Modal setOpen={setDialogOpen} open={dialogOpen}>
        <div className="p-10">
          <h2 className="text-xl text-center mb-4">
            {description ?? t("Default_Confirm")}
          </h2>
          <div className="text-center">
            {type === "Button" ? (
              <button
                onClick={handleConfirmClick}
                className="btn"
                disabled={isSubmitting}
              >
                {confirmationMessage ?? t("Form_Submit")}
              </button>
            ) : (
              <input
                type="submit"
                className="btn w-auto mr-3"
                disabled={isSubmitting}
                value={confirmationMessage ?? (t("Form_Submit") as string)}
                onClick={handleConfirmClick}
              />
            )}
            <ModalCloseButton setOpen={setDialogOpen}>
              <button className="btnSecondary w-auto ml-3">
                {dismissMessage ?? t("Form_Cancel")}
              </button>
            </ModalCloseButton>
          </div>
        </div>
      </Modal>
    </>
  );
}
